import { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

import { WithClasses } from '@/styles/types';

import { TileThemedTypography } from './TileThemedTypography';
import { TileFontSizeVariant, TileVariant } from './types';

const useStyles = makeStyles()((_theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 6px 8px',
  },
}));

export interface TileFooterLabelProps {
  children: ReactNode;
  tileVariant: TileVariant;
  /** A hex color that replaces the palette of `tileVariant`. */
  tileCustomColor?: string;
  fontSizeVariant: TileFontSizeVariant;
  classes?: WithClasses<typeof useStyles>;
}

export const TileFooterLabel = ({
  children,
  tileVariant,
  tileCustomColor,
  fontSizeVariant,
  ...props
}: TileFooterLabelProps) => {
  const { classes } = useStyles(undefined, { props });
  return (
    <div className={classes.root}>
      <TileThemedTypography
        variant="body-xs"
        tileVariant={tileVariant}
        tileCustomColor={tileCustomColor}
        fontSizeVariant={fontSizeVariant}
      >
        {children}
      </TileThemedTypography>
    </div>
  );
};
